import * as React from 'react'

import {noop} from '../../../utils/empty'
import createSimpleStream from '../../../utils/simpleStream'
import type {SimpleStream} from '../../../utils/simpleStream'

type ContextValue = {
  onReady(): void
  isLoading: boolean
}

export const sequenceLoaderDefaultContext = {onReady: noop, isLoading: false}
export const SequenceLoaderContext: React.Context<ContextValue> = React.createContext<ContextValue>(
  sequenceLoaderDefaultContext,
)
export function useSequenceLoaderReadyHandler(isReady?: boolean): void {
  const {onReady} = React.useContext(SequenceLoaderContext)
  React.useEffect(() => {
    if (isReady) {
      onReady()
    }
  }, [isReady, onReady])
}
const ResetLoadingStateContext: React.Context<SimpleStream<void>> =
  React.createContext(createSimpleStream())
type ResetLoadingStateProviderProps = {
  children: React.ReactNode
}
export function ResetLoadingStateProvider({children}: ResetLoadingStateProviderProps) {
  const resetLoadingState$ = React.useMemo(() => createSimpleStream(), [])
  return (
    <ResetLoadingStateContext.Provider value={resetLoadingState$}>
      {children}
    </ResetLoadingStateContext.Provider>
  )
}
export const useResetLoadingState = (): (() => unknown) =>
  React.useContext(ResetLoadingStateContext).fire
export function useOnResetLoadingState(handler: () => unknown): void {
  const resetLoadingState$ = React.useContext(ResetLoadingStateContext)
  React.useEffect(() => resetLoadingState$.subscribe(handler), [handler, resetLoadingState$])
}
